import app from './app/application/index'
import { initializeUserProfileModule } from './app/application/userProfileModule'
import apiCheck from 'api-check'

function bootstrap(profile, environment, appInfo) {
  const appModule = angular.module(app)
  initializeUserProfileModule(profile)
  appModule.constant('environment', environment)
  appModule.constant('applicationInfo', appInfo)

  //if this is not done, horrendous performance problems on forms.
  //you won't get apiCheck errors when developing forms with angular-formly
  //but at this point, we aren't going to add many new items until new client
  apiCheck.globalConfig.disabled = true

  angular.bootstrap(document, [app], {
    strictDi: true
  })

}
export default bootstrap